import type { FragmentType } from '@e-socna/data-layer';

import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

import { ContactInfo as ContactInfoStack } from '../../ContactInfo';
import type { ContactInfoCmp_ContactInfo_Fragment } from '../../ContactInfo';

interface Props {
  readonly contactInfo:
    FragmentType<typeof ContactInfoCmp_ContactInfo_Fragment> | null | undefined;
  readonly expanded: boolean;
}

export const ContactInfo = ({ contactInfo, expanded }: Readonly<Props>) => (
  <Collapse in={expanded} timeout="auto" unmountOnExit>
    <CardContent>
      {!contactInfo ? (
        <Typography gutterBottom variant="body2">
          Aucune information de contact disponible.
        </Typography>
      ) : (
        <ContactInfoStack compact contactInfo={contactInfo} />
      )}
    </CardContent>
  </Collapse>
);
